
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class CustomerAddressGrid extends Serenity.EntityGrid<CustomerAddressRow, any> {
        protected getColumnsKey() { return CustomerAddressColumns.columnsKey; }
        protected getDialogType() { return CustomerAddressDialog; }
        protected getIdProperty() { return CustomerAddressRow.idProperty; }
        protected getInsertPermission() { return CustomerAddressRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerAddressRow.localTextPrefix; }
        protected getService() { return CustomerAddressService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {
            this.editItem({ CustomerId: this.CustomerId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.CustomerId != null;
        }

        private _CustomerId: number;

        get CustomerId() {
            return this._CustomerId;
        }

        set CustomerId(value: number) {
            //debugger;
            if (this._CustomerId != value) {
                this._CustomerId = value;
                this.setEquality(CustomerAddressRow.Fields.CustomerId, value);
                this.refresh();
            }
        }
    }
}